import React from 'react';

function BredCrum({ children }) {
    return (
        <>
            <div className='bread'>{children}</div>
        </>
    );
}
export default BredCrum;